import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import { useWorkspace } from '../WorkspaceContext.js';

const BuildingsPanel = () => {
  const {
    interactionMode,
    startDrawing,
    startErasing,
    cancelInteraction,
    buildings,
    pendingBuildingDeletions,
    confirmBuildingDeletion,
    undoBuildingDeletion,
  } = useWorkspace();

  const drawing = interactionMode === 'draw-building';
  const erasing = interactionMode === 'erase-buildings';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {buildings.length === 1
          ? '1 Gebäude in dieser Region.'
          : `${buildings.length} Gebäude in dieser Region.`}
      </Typography>

      {!erasing && (
        <Button
          variant={drawing ? 'outlined' : 'contained'}
          startIcon={<AddIcon />}
          onClick={() => (drawing ? cancelInteraction() : startDrawing('building'))}
        >
          {drawing ? 'Zeichnen beenden' : 'Gebäude hinzufügen'}
        </Button>
      )}

      {drawing && (
        <Alert severity="info">
          Zeichnen Sie den Umriss des Gebäudes auf der Karte. Schließen Sie den Umriss mit einem
          Klick auf den ersten Punkt. Danach können Sie direkt das nächste Gebäude einzeichnen.
        </Alert>
      )}

      {!drawing && !erasing && (
        <Button
          variant="contained"
          color="error"
          startIcon={<AutoFixNormalIcon />}
          onClick={() => startErasing('buildings')}
        >
          Gebäude löschen
        </Button>
      )}

      {erasing && (
        <>
          <Alert severity="warning">
            Klicken Sie die Gebäude an, die Sie löschen möchten. Sie werden erst aus der Datenbank
            entfernt, wenn Sie das Löschen bestätigen.
          </Alert>
          <Typography variant="body2">
            {pendingBuildingDeletions.length === 1
              ? '1 Gebäude zum Löschen markiert.'
              : `${pendingBuildingDeletions.length} Gebäude zum Löschen markiert.`}
          </Typography>
          <Button
            variant="contained"
            color="error"
            disabled={pendingBuildingDeletions.length === 0}
            onClick={confirmBuildingDeletion}
          >
            Löschen bestätigen
          </Button>
          <Button variant="outlined" color="inherit" onClick={undoBuildingDeletion}>
            Löschen rückgängig
          </Button>
        </>
      )}
    </Box>
  );
};

export default BuildingsPanel;
